import { getHaveInjector } from '../../EMR_Integration/react_webInjector.ts';

// apiUtils.js
import { convertToArray, convertAccessLevelForFrontend } from '../Misc/utils';
// Function to fetch user details
export const fetchUserDetails = async (apiClient) => {
  try {
    const data = await apiClient.getStats({});
    return data;
  } catch (error) {
    console.error('Error fetching user details:', error);
  }
};

// Function to fetch user configs
export const fetchUserConfigs = async (apiClient) => {
  try {
    const response = await apiClient.getUserConfigs();
    const newSharedConfigs = response?.configs || [];
    return newSharedConfigs;
  } catch (error) {
    console.error('Error fetching shared configs:', error);
  }
};

// Function to fetch shared configs
export const fetchSharedConfigs = async (apiClient, userEmail) => {
  try {
    if (!userEmail) return;
    const domain = userEmail.split('@')[1];
    const response = await apiClient.getUserSharedConfigs('@' + domain);
    const newSharedConfigs = response?.sharedConfigs || [];
    return newSharedConfigs;
  } catch (error) {
    console.error('Error fetching shared configs:', error);
  }
};

// Function to fetch shared template details
export const fetchSharedTemplateDetails = async (apiClient, configID) => {
  try {
    const statsData = await apiClient.getStats({});
    if (!statsData || !statsData.email) {
      console.log('Error getting user stats');
      return;
    }
    const email = statsData.email;
    const domain = email.split('@')[1];
    const sharedConfigsData = await apiClient.getUserSharedConfigs(
      '@' + domain,
    );
    if (!sharedConfigsData || !sharedConfigsData.sharedConfigs) {
      console.log('Error getting user shared configs');
      return;
    }
    const foundConfig = sharedConfigsData.sharedConfigs.find(
      (config) => config.sharedConfigId === configID,
    );
    return foundConfig;
  } catch (error) {
    console.error('Error fetching shared template details:', error);
  }
};

// Function to fetch shared configs details
export const fetchUserSharedConfigsDetails = async (
  apiClient,
  configID,
  userEmail,
) => {
  try {
    const response = await apiClient.shareTemplateDetails(configID);
    const sharedConfigsDetials = response && response.accessMapping;
    const resultArray =
      sharedConfigsDetials && Object.keys(sharedConfigsDetials).length > 0
        ? convertToArray(sharedConfigsDetials)
        : [];
    const sharedData = resultArray.map((config) => ({
      email: config.email,
      access: convertAccessLevelForFrontend(config.access),
    }));
    const filteredSharedData = sharedData
      ? sharedData.filter((entry) => entry.email !== userEmail)
      : [];
    return filteredSharedData || [];
  } catch (error) {
    console.error('Error fetching shared configs:', error);
  }
};

export const fetchInjector = async (setHaveInjector) => {
  try {
    const haveInjector = await getHaveInjector();
    setHaveInjector(haveInjector);
  } catch (error) {
    console.error('Error fetching injector:', error);
  }
};
